import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    container: 'p-2 b b-grey-70 bg-white flex gap-1 shadow-xs relative md:px-4',
    iconError: 'c-red-30',
    iconSuccess: 'c-green-30',
    message: 'text-sm c-grey-10 py-2'
  },
  closeIconSize: 'md',
  closeVariant: 'icon',
  iconSize: 'lg'
} satisfies VfConfig['notification']
